import { Box, Checkbox } from '@mui/material';
import React from 'react';

export default function AGGridHeaderCheckboxSimple(params, checkAll) {
    const { displayName, column } = params;
  const allVisibleNodes = [];
  params.api.forEachNodeAfterFilter(node => allVisibleNodes.push(node));
    const checked = allVisibleNodes.length > 0 && allVisibleNodes.every(x => x.data[column.colId]);

    return <Box>       
        <Checkbox checked={checked} onClick={(e) => { e.preventDefault(); e.stopPropagation(); checkAll(params, checked); }} />
        {displayName}
    </Box>;
};
